<template>
  <app-modal
    v-if="show"
    :maxWidth="maxWidth"
    :maxHeight="maxHeight"
    :isClickMaskClose="false"
    @close="hideModal"
  >
    <el-form
      class="object-types-new-form"
      ref="objectTypesNewForm"
      :rules="rules"
      :model="objectTypes"
    >
      <h3 class="object-types-new-form__title">
        {{ $t("object_type_new_title") }}
      </h3>

      <el-form-item
        class="object-types-new-form__item"
        :label="$t('object_type_new_code')"
        prop="code"
      >
        <el-input
          class="show-word-limit-pad"
          v-model="objectTypes.code"
          maxlength="20"
          show-word-limit
          autofocus
        ></el-input>
      </el-form-item>

      <el-form-item
        class="object-types-new-form__item"
        :label="$t('object_type_new_name')"
        prop="name"
      >
        <el-input
          class="show-word-limit-pad"
          v-model="objectTypes.name"
          maxlength="100"
          show-word-limit
        ></el-input>
      </el-form-item>

      <el-form-item
        class="object-types-new-form__item"
        :label="$t('object_type_new_system')"
      >
        <el-checkbox-group v-model="objectTypes.used">
          <el-checkbox
            v-for="system in systems"
            :key="system.id"
            :label="system.id"
          >
            {{ system.name }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item
        class="object-types-new-form__item object-types-new-form__action"
      >
        <el-button @click="hideModal">
          {{ $t("object_type_new_cancel") }}
        </el-button>

        <el-button type="success" @click="submitForm('objectTypesNewForm')">
          {{ $t("object_type_new_save") }}
        </el-button>
      </el-form-item>
    </el-form>
  </app-modal>
</template>

<script>
export default {
  name: "ObjectTypesNew",
  components: {
    AppModal: () =>
      import(
        /* webpackChunkName: "appModal" */ "@/components/library.blocks/AppModal.vue"
      )
  },
  props: {
    maxWidth: {
      type: String,
      default: "100%"
    },
    maxHeight: {
      type: String,
      default: "100%"
    },
    show: {
      type: Boolean,
      default: false
    },
    systems: Array
  },
  data() {
    return {
      objectTypes: {
        code: "",
        name: "",
        used: []
      },
      rules: {
        code: [
          {
            required: true,
            message: this.$t("object_type_new_code_rule"),
            trigger: "change"
          }
        ],
        name: [
          {
            required: true,
            message: this.$t("object_type_new_name_rule"),
            trigger: "change"
          }
        ]
      }
    };
  },
  computed: {
    disabledAction() {
      return true;
    }
  },
  methods: {
    hideModal() {
      this.$emit("close");
    },
    save() {
      this.$emit("add", this.objectTypes);
    },
    reset() {
      this.objectTypes = {
        code: "",
        name: "",
        used: []
      };
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save();
          this.reset();
          this.hideModal();
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss">
.object-types-new-form {
  .object-types-new-form__title {
    text-align: left;
    padding: 5px 10px;
  }

  .object-types-new-form__item {
    padding: 0 10px;
  }

  .object-types-new-form__action {
    text-align: right;
  }
}
</style>
